

import { format } from "date-fns";
import isBefore from "date-fns/isBefore";
import isAfter from "date-fns/isAfter";

import { TIME_FORMAT } from "../../../../constants/formats";
import { getDefaultDateValue, valueToDate } from "./DateTimePicker.utils";

type TValue = { start?: string, end?: string; transformStart?: string };

interface IDefaultDateRangeOptions {
    start: {
        defaultTime?: string,
        hourRoundingValue?: number;
    },
    end: {
        defaultTime?: string,
        hourRoundingValue?: number;
    }
};

export const getDefaultDateRangeValues = (value: TValue | undefined, options: IDefaultDateRangeOptions) => {

    const reference = new Date();

    let start = value?.start;
    let startDate = start ? valueToDate(start) : undefined;

    if (!start || !startDate) {
        start = getDefaultDateValue(reference, {
            minDate: reference,
            defaultTime: options.start.defaultTime,
            hourRoundingValue: options.start.hourRoundingValue
        });
        startDate = start ? new Date(start) : undefined;
    };

    let end = value?.end;

    if (!end && startDate) {
        end = getDefaultDateValue(startDate, {
            minDate: startDate,
            defaultTime: options.end.defaultTime,
            hourRoundingValue: options.end.hourRoundingValue
        });
    };

    return { end, start };
}
